import { Logger } from '@/utils/logger';
import TagManager from 'react-gtm-module';

const logger = new Logger('googleTagManager');

function configureGTM(settings: { googleTagManagerId: string; googleTagManagerAuth: string }) {
  let initialised = false;

  const init = () => {
    if (settings.googleTagManagerId && !initialised) {
      logger.debug(`Initializing GoogleTagManager`);
      TagManager.initialize({
        gtmId: settings.googleTagManagerId,
        auth: settings.googleTagManagerAuth || '',
      });
      initialised = true;
    }
  };

  init();
}

export default configureGTM;
